import * as React from 'react';
import {
  asymmetryModeOptions,
  IAsymmetryModeOption,
} from '../../../../data/providers/settings/reports/asymmetryReportSettingsProvider';
import { KEYS } from '../../../../keys';

import { Select } from '../Select';

interface IProps {
  value?: IAsymmetryModeOption;
  onChange: (s: IAsymmetryModeOption) => void;
  disabled?: boolean;
  style?: React.CSSProperties;
}

/**
 * @description select control for weight units
 * @param props
 * @returns
 */
export const AsymmetrySelect = (props: IProps): React.ReactElement => {
  return (
    <Select
      style={props.style}
      name='asymmetry-mode'
      options={asymmetryModeOptions}
      placeholder='Mode...'
      controlShouldRenderValue
      value={props.value}
      onChange={props.onChange}
      cache={false}
      inputId={KEYS.ASYMMETRY_MODE_SELECT}
      isDisabled={props.disabled}
    />
  );
};
